function typeOf( obj ) {
  return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase()
}

export default typeOf



/** WEBPACK FOOTER **
 ** ../app/lib/utils/typeOf.js
 **/